(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/preview/components/gift-info.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/preview/components/gift-info.js');
"use strict";


const {
  EMAIL,
  PHONE
} = svs.tickets_giftshop.constants.names;
const GiftInfo = _ref => {
  let {
    email,
    phone,
    receiverType,
    dateString,
    totalProducts,
    totalProductSum
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "tg-preview-info-container u-flex u-flex-justify-content-center"
  }, React.createElement("div", {
    className: "tg-preview-info f-body u-flex u-flex-align-items-center"
  }, React.createElement("div", {
    className: "tg-preview-info-left"
  }, React.createElement("p", {
    className: "p margin-bottom-0"
  }, "".concat(totalProducts > 1 ? 'Lotterna' : 'Lotten'), " skickas till:"), React.createElement("p", {
    className: "p margin-bottom-0"
  }, "".concat(totalProducts > 1 ? 'Lotterna' : 'Lotten'), " skickas:"), React.createElement("p", {
    className: "p margin-bottom-0"
  }, "Antal lotter:"), React.createElement("p", {
    className: "p margin-bottom-0"
  }, "Pris:")), React.createElement("div", {
    className: "tg-preview-info-right u-overflow-threedots"
  }, React.createElement("p", {
    className: "p margin-bottom-0 tg-truncate-field data-hj-suppress"
  }, receiverType === EMAIL ? email : phone), React.createElement("p", {
    className: "p margin-bottom-0"
  }, dateString), React.createElement("p", {
    className: "p margin-bottom-0"
  }, "".concat(totalProducts || 0, " st")), React.createElement("p", {
    className: "p margin-bottom-0"
  }, "".concat(totalProductSum || 0, " kr"))))));
};
svs.tickets_giftshop.preview.components.GiftInfo = GiftInfo;

 })(window);